<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadCompanies(1, null, true)">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addLoad">{{ $t('add_load') }}</vs-button>
      </template>

      <vs-input :placeholder="$t('company_name')" v-model="loadSearchParams.companyName" class="w-full"/>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadCompanies(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="loadDataContainer" :title="$t('load')" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <span class="mr-2" v-text="$t('master_remaining_balance') + ':'"></span>
        <vs-chip color="warning" id="masterBalanceSms">
          <span class="align-middle">SMS:</span>&nbsp;
          <span v-text="smsBalance" class="align-middle font-16"></span>
        </vs-chip>
        <vs-chip color="primary" id="masterBalanceLms">
          <span class="align-middle">LMS:</span>&nbsp;
          <span v-text="lmsBalance" class="align-middle font-16"></span>
        </vs-chip>
      </template>

      <vs-table hover-flat v-if="companies && companies.length" :data="companies">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th v-text="$t('company_name')"></vs-th>
          <vs-th v-text="$t('total_loaded_sms')"></vs-th>
          <vs-th v-text="'SMS'"></vs-th>
          <vs-th v-text="'LMS'"></vs-th>
          <vs-th v-text="$t('balance')"></vs-th>
          <vs-th v-text="$t('last_load_update')"></vs-th>
          <vs-th class="text-center" v-text="$t('action')"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="key" v-for="(tr, key) in data">
            <vs-td v-text="tr.count"></vs-td>
            <vs-td v-text="tr.name"></vs-td>
            <vs-td v-text="tr.total_loaded_sms"></vs-td>
            <vs-td v-text="tr.total_sent_sms"></vs-td>
            <vs-td v-text="tr.total_sent_lms"></vs-td>
            <vs-td v-text="getBalance(tr)"></vs-td>
            <vs-td>{{ tr.last_load_date | readableDate }}</vs-td>
            <vs-td class="text-center">
              <div class="flex justify-center">
                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-list" size="small" @click.prevent="viewSummary(tr.id)"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>

      <template slot="footer">
        <paginate
          :total="companyPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadCompanies"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('add_load')" :active.sync="modals.add" size="md">
      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('company')"></label>
        <v-select :options="companyOptions" :reduce="label => label.value" :placeholder="$t('company')" v-model="loadFormData.companyId" class="md:mb-0" />
        <validation-error :model-error="loadFormErrors.companyId"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('amount')"></label>
        <vs-input-number v-model="loadFormData.amount"/>
        <validation-error :model-error="loadFormErrors.amount"></validation-error>
      </div>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="addLoadButton" color="primary" type="filled" @click.prevent="submitLoad">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="`${companyName} ${$t('load_summary')}`" :active.sync="modals.summary" size="md">
      <div id="summaryViewDataContainer" class="vs-con-loading__container">
        <vs-table hover-flat v-if="loadSummary && loadSummary.length" :data="loadSummary">
          <template slot="thead">
            <vs-th class="text-center" v-text="$t('no')"></vs-th>
            <vs-th class="text-center" v-text="$t('amount')"></vs-th>
            <vs-th class="text-center" v-text="$t('date')"></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="key" v-for="(tr, key) in data">
              <vs-td class="text-center" v-text="key + 1"></vs-td>
              <vs-td class="text-center" v-text="tr.amount"></vs-td>
              <vs-td class="text-center">{{ tr.created_at | readableDate }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </modal>
  </div>
</template>

<script>
import Paginate from '@/components/Paginate'
import Modal from '@/components/Modal'
import Pagination from '@/mixins/paginate'
import MessageLoad from '@/models/MessageLoad'

export default {
  name: 'Admin.Messages.Load',
  mixins: [Pagination],
  components: {
    Paginate,
    Modal
  },
  data () {
    return {
      companies: {},
      companyPages: 0,
      companyOptions: [],
      isTableLoading: false,
      smsBalance: null,
      lmsBalance: null,
      loadSummary: [],
      companyName: '',
      loadFormData: {
        companyId: '',
        amount: 0
      },
      loadFormErrors: [],
      loadSearchParams: {
        companyName: ''
      },
      modals: {
        add: false,
        summary: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        this.resetLoadFormData()
      }
    },
    'modals.summary' (val) {
      if (!val) {
        this.loadSummary = []
      }
    }
  },
  mounted () {
    this.$vs.loading({color: '#fff', container: '#masterBalanceSms', scale: 0.35})
    this.$vs.loading({color: '#fff', container: '#masterBalanceLms', scale: 0.35})

    this.loadCompanies(this.initialPage, null)
  },
  methods: {
    async loadCompanies (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#loadDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await MessageLoad.findAll({ ...this.loadSearchParams, page, itemPerPage })
      this.companies = response.data.data
      this.companyPages = response.data.meta.pagination.last_page
      this.companyOptions = response.data.meta.options.companies
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#loadDataContainer > .con-vs-loading')

      this.loadBalance()
    },
    async loadBalance () {
      const response = await MessageLoad.getBalance()

      this.smsBalance = response.data.smsBalance
      this.lmsBalance = response.data.lmsBalance

      this.$vs.loading.close('#masterBalanceSms > .con-vs-loading')
      this.$vs.loading.close('#masterBalanceLms > .con-vs-loading')
    },
    getBalance (company) {
      return company.total_loaded_sms - ((company.total_sent_lms * 3) + company.total_sent_sms)
    },
    async viewSummary (id) {
      this.$vs.loading({container: '#summaryViewDataContainer'})

      try {
        this.modals.summary = true
        const response = await MessageLoad.viewSummary({ id })

        this.loadSummary = response.data.company.message_loads
        this.companyName = response.data.company.name
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#summaryViewDataContainer > .con-vs-loading')
    },
    addLoad () {
      this.modals.add = true
    },
    async submitLoad () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addLoadButton', scale: 0.45})

      try {
        const response = await MessageLoad.store(this.loadFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.add = false

        this.loadCompanies(1, null)
        this.resetLoadFormData()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.loadFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#addLoadButton > .con-vs-loading')
    },
    resetLoadFormData () {
      this.loadFormData = {
        companyId: '',
        amount: 0
      }
      this.loadFormErrors = []
    }
  }
}
</script>

<style lang="scss">
  #addLoadButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
